// src/components/AdminGuard.js
import React from "react";
import { Container, Paper, Typography, Alert, Button } from "@mui/material";
import { AdminPanelSettings } from "@mui/icons-material";
import { ADMIN_CONFIG } from "../config/appConfig";

const AdminGuard = ({ user, children, onBackToHome }) => {
  // Check if user is admin using centralized config
  const isAdmin = user && ADMIN_CONFIG.isAdmin(user.email);

  if (!isAdmin) {
    return (
      <Container maxWidth="sm" sx={{ mt: 4 }}>
        <Paper elevation={3} sx={{ p: 4, textAlign: "center" }}>
          <AdminPanelSettings color="error" sx={{ fontSize: 60, mb: 2 }} />
          <Typography variant="h5" gutterBottom>
            Access Denied
          </Typography>
          <Alert severity="error" sx={{ mb: 3 }}>
            You don't have permission to access the admin panel. Only
            administrators can view this page.
          </Alert>
          <Button variant="contained" onClick={onBackToHome}>
            Back to Home
          </Button>
        </Paper>
      </Container>
    );
  }

  // If user is admin, render the admin content
  return children;
};

export default AdminGuard;
